import angular from 'angular';

export class MeurhAdmissoesestagiarioDadoscontatoFormController implements angular.IController {

    static $inject = [];

    public entity: any;
    public form: any;

    constructor() {/**/}

    preenchePix(): void {
        if (this.entity.tiporecebimentobolsa === '256') { // email
            this.entity.chavepix = this.entity.email;
        } else if (this.entity.tiporecebimentobolsa === '512' && this.valorExiste(this.entity.dddcel) && this.valorExiste(this.entity.celular)) { // celular
            this.entity.chavepix = this.entity.dddcel + this.entity.celular;
        }
    }

    valorExiste(valor: any) {
        return valor !== '' && valor !== undefined && valor !== null ? true : false;
    }
}
